import {http} from '../shared/http'

export const contentSummaryState = {
    defaultState: {
        contentSummary: null,
    },
    actions: {
        setContentSummary: (summary, state) => ({...state, contentSummary: summary}),
        refreshContentSummary: (_, state, setSharedState) => {
            http.get('/api/v1/content-summary')
                .then(res => setSharedState(s => ({...s, contentSummary: res.data.contentSummary})))
                .catch(() => {})
            return state
        },
    },
}
